module.exports = __webpack_public_path__ + "static/media/soap.baa59e44.jpg";